// extracted by mini-css-extract-plugin
module.exports = {"noReviewsContainer":"NoReviews__noReviewsContainer___3U8ch","noReviewsImage":"NoReviews__noReviewsImage___1PISv"};